import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { TMachineMaintenanceState } from '../reducers';
import { TNavigationTreeNode } from './navigation.models';
import * as NavigationActions from './navigation.action';
import * as NavigationSelectors from './navigation.selectors';
import { map } from 'rxjs/operators';
import { UnifiedLoginService } from '@monorepo/services';

@Injectable({
  providedIn: 'root',
})
export class NavigationFacade {
  constructor(private store: Store<TMachineMaintenanceState>, private unifiedIdService: UnifiedLoginService) {}

  getNavigationInfoByFeature() {
    return this.store.pipe(select(NavigationSelectors.selectNavigation)).pipe(
      map((res) => ({
        ...res,
        navigationTreeList: res.navigationTreeList
          .map((tree) => this.#filterNavNodeByFeature(tree))
          .filter((head) => {
            return head.id === 'HOME' ? true : head.children.length;
          }),
      })),
    );
  }

  selectNavigationItem(navigationTreeNode: TNavigationTreeNode) {
    this.store.dispatch(new NavigationActions.SelectNavigationItem(navigationTreeNode));
  }

  getSelectedNode() {
    return this.store.pipe(select(NavigationSelectors.selectNavigationItem));
  }

  setCustomPageHeader(val: string | null) {
    this.store.dispatch(new NavigationActions.SetCustomPageHeader(val));
  }

  getCustomPageHeader() {
    return this.store.pipe(select(NavigationSelectors.getCustomPageHeader));
  }

  #filterNavNodeByFeature(treeNodes: TNavigationTreeNode) {
    const updatedNavNode: TNavigationTreeNode = {
      ...treeNodes,
      children: treeNodes.children.filter(
        (child) => child.featureId && this.unifiedIdService.isFeaturePermissionExist('MM_APP_SOLVEI8', child.featureId),
      ),
    };
    updatedNavNode.children = updatedNavNode.children.map((child) => this.#filterNavNodeByFeature(child));
    return updatedNavNode;
  }

  setSelectedFactoryIds(payload: string[]) {
    this.store.dispatch(new NavigationActions.SetSelectedFactoryIds(payload));
  }

  getSelectedFactoryIds() {
    return this.store.pipe(select(NavigationSelectors.getSelectedFactoryIds));
  }
}

export type TGetNavigationInfo = ReturnType<NavigationFacade['getNavigationInfoByFeature']>;
export type TGetNavigationItem = ReturnType<NavigationFacade['getSelectedNode']>;
export type TGetCustomPageHeader = ReturnType<NavigationFacade['getCustomPageHeader']>;
